// extracted by mini-css-extract-plugin
export default {"container":"notFound_container__b+EzB","col":"notFound_col__K7mG7","image":"notFound_image__BIQD8","rightCol":"notFound_rightCol__ggV1N"};